import DateUtil from './../util/DateUtil';

function convertData(data) {
    if (!data) {
        return data;
    }

    if (typeof data == 'string') {
        return data;
    }
    if (!data.frameDOTypeList) {
        return data;
    }
    let dataTypeArray = data.frameDOTypeList.split(',');

    for (let i = 0; i < dataTypeArray.length; i++) {
        let columnTypeConfigArray = dataTypeArray[i].split(':');

        let colName = columnTypeConfigArray[0];
        let colType = columnTypeConfigArray[1];

        if (colType == 'DataStore') {
            let DataStoreValue = data[colName];
            for (let i = 0; i < DataStoreValue.length; i++) {
                let value = DataStoreValue[i];
                let converValue = convertData(value);
                DataStoreValue[i] = converValue;
            }
            data[colName] = DataStoreValue;
        } else if (colType == 'DataObject') {
            data[colName] = convertData(data[colName]);
        } else if (colType == 'Date' && data[colName] != '') {
            data[colName] = DateUtil.stringToDate(data[colName], 'yyyyMMddHHmmss');
        } else if (colType == 'Date' && data[colName] == '') {
            data[colName] = null;
        } else if (colType == 'Number') {
            data[colName] = Number(data[colName]);
        } else if (colType == 'Doule') {
            data[colName] = Number(data[colName]);
        } else if (colType == 'BigDecimal') {
            data[colName] = Number(data[colName]);
        }else if(colType == 'null'){
            data[colName] = null;
        }
    }
    return data;
}

export default {
    convertData
};
